import { IconButton } from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'
import { useOptionsPopover } from '@/core/popover/popover-hooks'
import { DefaultPopover } from '@/core/popover/DefaultPopover'
import { FilterPopover } from './FilterPopover'
import { useCollectionViewContext } from '@/objects/collection-view/top-bar/CollectionViewPageContext.ts'
import { useDiRef } from '@/common/react/di-hooks.ts'
import type { CollectionViewsService } from '@/objects/services/CollectionViewsService.ts'
import { useObservable } from '@/common/react/observable-hooks.ts'
import { useTutorialTarget } from '@/tutorial/TutorialContext'

export function FilterButton() {
  const { collectionId } = useCollectionViewContext()
  const collectionViewsService = useDiRef<CollectionViewsService>('CollectionViewsService')
  const activeTab = useObservable(collectionViewsService.getActiveTab$(collectionId), () =>
    collectionViewsService.getActiveTab(collectionId),
  )
  const popover = useOptionsPopover()
  const tutorialTargetRef = useTutorialTarget('collection-filters-button')

  return (
    <>
      <IconButton
        ref={tutorialTargetRef}
        disabled={!activeTab}
        size="small"
        onClick={(e) => {
          popover.openPopover(e.currentTarget)
        }}
      >
        <FilterListIcon fontSize="medium" />
      </IconButton>
      <DefaultPopover
        anchorEl={popover.anchorEl}
        close={popover.closePopover}
        slots={{
          popover: {
            anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
            transformOrigin: { vertical: 'top', horizontal: 'right' },
          },
        }}
      >
        <FilterPopover />
      </DefaultPopover>
    </>
  )
}
